import { render, staticRenderFns } from "./PlaceOrderSecond.vue?vue&type=template&id=9a7bd4f8&scoped=true&"
import script from "./PlaceOrderSecond.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderSecond.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOrderSecond.vue?vue&type=style&index=0&id=9a7bd4f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7bd4f8",
  null
  
)

export default component.exports